import { _ as _extends } from './_rollupPluginBabelHelpers-8c92bac3.js';
import React__default from 'react';

const ChevronRightSVG = props => /*#__PURE__*/React__default.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React__default.createElement("path", {
  className: "motorway-svg-fill",
  d: "M18 12l-6-9H6l6 9-6 9h6.01z",
  fillRule: "evenodd"
}));

export default ChevronRightSVG;
